import ClientService from '../../../services/client-service';
import getDealFileListDataQuery from '../../../graphql/query/get-deal-file-list-data.graphql';
import saveDealFileMutation from '../../../graphql/mutation/save-deal-file.graphql';
import deleteDealFileListMutation from '../../../graphql/mutation/delete-deal-file-list.graphql';
import deleteDealFileGroupMutation from '../../../graphql/mutation/delete-deal-file-group.graphql';
import saveDealFileGroupOrderSettingsMutation
  from '../../../graphql/mutation/save-deal-file-group-order-settings.graphql';

export default class DealFilesApi {
  public static getDealFileListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealFileListDataQuery, payload);
  }

  public static saveDealFile(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealFileMutation, payload);
  }

  public static deleteDealFileList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteDealFileListMutation, payload);
  }

  public static deleteDealFileGroup(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteDealFileGroupMutation, payload);
  }

  public static saveDealFileGroupOrderSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealFileGroupOrderSettingsMutation, payload);
  }
}
